import type { Resolver } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import type { z } from "zod";

/**
 * Single documented escape hatch for zodResolver's strict generic signature.
 *
 * zodResolver requires the resolver's input type to match useForm's field
 * values exactly, but zod schemas with `.default()` / `coerce` diverge their
 * input and output types, making `zodResolver(schema)` unassignable to
 * `Resolver<z.infer<T>>` even when runtime behavior is correct.
 *
 * This wrapper intentionally erases that input/output divergence at the type
 * level only. Runtime behavior is identical to calling zodResolver directly.
 */
export function formResolver<T extends z.ZodTypeAny>(
  schema: T,
): Resolver<z.infer<T>> {
  return zodResolver(schema) as unknown as Resolver<z.infer<T>>;
}
